<app-header-search addText="Add User" headerText="User Management" />

<table>
  <thead>
    <tr>
      <th>User</th>
      <th>Email</th>
      <th>Group</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Stan Lee</td>
      <td>Stan.Lee&#64;gmail.com</td>
      <td>Group 1</td>
      <td></td>
    </tr>
    <tr>
      <td>Stan Lee</td>
      <td>Stan.Lee&#64;gmail.com</td>
      <td>Group 1</td>
      <td></td>
    </tr>
    <tr>
      <td>Stan Lee</td>
      <td>Stan.Lee&#64;gmail.com</td>
      <td>Group 1</td>
      <td></td>
    </tr>
    <tr>
      <td>Stan Lee</td>
      <td>Stan.Lee&#64;gmail.com</td>
      <td>Group 1</td>
      <td></td>
    </tr>
    <tr>
      <td>Stan Lee</td>
      <td>Stan.Lee&#64;gmail.com</td>
      <td>Group 1</td>
      <td></td>
    </tr>
    <tr>
      <td>Stan Lee</td>
      <td>Stan.Lee&#64;gmail.com</td>
      <td>Group 1</td>
      <td></td>
    </tr>
  </tbody>
</table>
